// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1SeH3","normalElement":"styles_normalElement__UVWKv"};